import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence } from 'framer-motion';
import { motion } from 'framer-motion';
import { scaleMotionProps3 } from 'constants/animationProps';
import fundmoreai from 'assets/fundmoreai.png';
import styles from '../../../styles/features/onboarding-layout.module.css';
/**
 * Renders a page component with a greeting message.
 *
 * @param {Object} props - The component props.
 * @param {string} props.user - The user's name.
 * @returns {JSX.Element} The rendered page component.
 */
const Page0 = ({ user }) => {
  const { t } = useTranslation(['onboarding']);
  return (
    <div className={styles.contentWrapper}>
      <AnimatePresence mode="wait">
        <motion.div
          {...scaleMotionProps3}
          className={`${styles.formContainer} ${styles.fadeInContent}`}
        >
          <div className={styles.logoContainer}>
            <img src={fundmoreai} alt="Fundmore" className={styles.logoIcon} />
            <div className={styles.logoText}>
              <span className={styles.logoTextLight}>fund</span>
              <span className={styles.logoTextBold}>more</span>
              <span className={styles.logoTextGreen}>.ai</span>
            </div>
          </div>

          <div className={styles.progressContainer}>
            <div className={`${styles.progressBar} ${styles.progressBarMuted}`} />
          </div>

          <h2 className={styles.heading}>
            {t('onboarding:greeting', { name: user })}
          </h2>
          <p className={styles.subheading}>
            {t('onboarding:welcomeMessage')}
          </p>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Page0;
